<template>
  <div class="turn-container">
    <img class="chahao" src="../assets/cha3.png" alt="" @click="handelbook3Dreadoff">
    <img class="page1" src="../assets/readpage.png" alt="" @click="goToPreviousPage">
    <div class="turn-content">
      <div ref="turnContainer">
        <!-- <div> -->
          <img class="tupian" v-for="(item, index) in imgList" :key="index" :src="item.imgurl" alt="">
        <!-- </div> -->
      </div>
    </div>
    <img class="page2" src="../assets/readpage.png" alt="" @click="goToNextPage">
  </div>
</template>
<script setup>
import { ref, reactive, nextTick, onMounted } from 'vue'
import $ from 'jquery'
import turn from '../utils/turn'
import { post } from '@/services/api';
import { ElMessage } from 'element-plus';

const props = defineProps({
  book_info: {
    type: Object,
    default: {},
  },
});
var {book_info} = reactive(props);

const pagenum = ref(1);

const turnContainer = ref(null);
let turnInstance = null;

const currentPage = ref(1)

const imgList = ref([])

onMounted(() => {
  bookList();
})
const onTurn = () => {
  nextTick(() => {
    turnInstance  = $(turnContainer.value).turn({
      height: 566, //高度
      width: 556, //宽度
      display: 'double', //单页显示/双页显示  single/double
      elevation: 50,
      duration: 600, //翻页速度(毫秒), 默认600ms
      gradients: true, //翻页时的阴影渐变, 默认true
      autoCenter: true, //自动居中, 默认false
      acceleration: true, //硬件加速, 默认true, 如果是触摸设备设置为true
      direction: 'rtl',  // 设置翻页方向：从左向右
      page: 2, //设置当前显示第几页
      pages: imgList.value.length, //总页数
      when: {
        //监听事件
        // turning: function (e, page, view) {
        //   console.log(e, page, view)
        //   // 翻页前触发
        // },
        turned: function (e, page) {
          console.log(e, page)
          if(page+3 > imgList.value.length){
            bookList(1);
          }
          // 翻页后触发
        },
      },
    })
  })
};
// 获取书籍
const bookList = async(leixing)=>{
  let parameter = {
      num: book_info.num,  // 书的标识号
      page: pagenum.value,
    };
    try {
      const response = await post("/api/book/getbookpic", parameter); // 发送请求
      // 请求成功
      if(response.data == ""){
        ElMessage({
          message: "已到最后一页",
        })
        return
      }
      imgList.value.push(...response.data);
      if(pagenum.value == 1){
        onTurn();
      }else{
        // 更新 turn.js，添加新的一页
        for(let i = 0; i < response.data.length; i++){
          let element = $(`<img class="tupian" src="${response.data[i].imgurl}" alt="">`);
          turnInstance.turn("addPage", element, imgList.value.length - 10 + i + 1);
        }

        turnInstance.turn('resize');
        // 更新翻页控件的页数和当前页
        turnInstance.turn('pages', imgList.value.length);
        if(leixing == 2){
          turnInstance.turn('next');
        }
      }
      pagenum.value++;
    } catch (err) {
      // 请求失败
      ElMessage({
        message: err,
        type: 'error',
      })
    } finally {
      // 请求结束
    }
};

const goToPreviousPage = () => {
  if (turnInstance && turnInstance.turn('hasPage', 1)) {
    turnInstance.turn('previous');
  }
};

const goToNextPage = () => {
  // console.log(turnInstance.turn('page'))
  // console.log(turnInstance.turn('hasPage', turnInstance.turn('page')+3))
  if (turnInstance && turnInstance.turn('hasPage', turnInstance.turn('page')+3)) {
    turnInstance.turn('next');
  }else{
    bookList(2);
  }
};

// 定义子组件的 `emit` 事件
const emit = defineEmits(['handelbook3Dreadoff']);
// 关闭读书弹窗
const handelbook3Dreadoff = ()=>{
  emit('handelbook3Dreadoff', false);
};
</script>
<style scoped>
.turn-container {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
/* .turn-content {
  width: 100%;
  margin: 0px auto;
  overflow: hidden;
} */
.tupian{
  height: 100%;
  object-fit: fill;
  opacity: 0;
}
.page{
  opacity: 1;
}
.chahao{
  width: 40px;
  height: 40rpx;
  position: absolute;
  top: 30px;
  right: 60px;
  cursor: pointer;
  transition: 0.3s;
}
.chahao:hover{
  transform: scale(1.3) rotate(180deg);
}
.page1{
  width: 50px;
  height: 50px;
  border-radius: 50%;
  cursor: pointer;
  transition: 0.3s;
  margin-right: 20px;
}
.page2{
  width: 50px;
  height: 50px;
  transform: rotate(180deg);
  border-radius: 50%;
  cursor: pointer;
  transition: 0.3s;
  margin-left: 20px;
}
.page1:hover{
  transform: scale(1.2);
}
.page2:hover{
  transform: scale(1.2) rotate(180deg);
}
</style>